<template>
  <div class="table-container">
    <!-- 顶部表格 -->
    <table-section
      :previewMode="disableMode"
      :rows="topRows"
      :col-count="7"
      section-type="top"
      @checkbox-change="handleCheckboxChange"
    />

    <!-- 中间表格 -->
    <table-section
      :previewMode="disableMode"
      :rows="middleRows"
      :col-count="7"
      section-type="middle"
      @checkbox-change="handleCheckboxChange"
    />

    <!-- 底部表格 -->
    <table-section
      v-if="previewMode"
      :rows="bottomRows"
      :col-count="7"
      section-type="bottom"
    />
  </div>
</template>

<script>
import TableSection from "./TableSection.vue";
import TableConfig from "./table-config";
import "./styles/table-styles.scss";

export default {
  name: "DynamicFixedTable",
  components: {
    TableSection,
  },
  props: {
    viewData: {
      type: Array,
      default: () => [],
    },
    disableMode: {
      type: Boolean,
      default: false,
    },
    previewMode: {
      type: Boolean,
      default: false,
    },
    perviewInfo: {
      type: Object,
      default: () => {},
    },
    lang: {
      type: String,
    },
  },
  computed: {
    topRows() {
      if (!this.viewData.length) return [];
      const headerData = this.viewData[0];
      let topRows = TableConfig.generateTopRows(
        headerData,
        this.previewMode,
        this.lang,
        this
      );
      return topRows;
    },

    middleRows() {
      if (this.viewData.length < 6) return [];
      const middleData = this.viewData.slice(1, 6);
      return TableConfig.generateMiddleRows(
        middleData,
        this.previewMode,
        this.lang
      );
    },

    bottomRows() {
      return TableConfig.generateBottomRows(this.perviewInfo, this.lang);
    },
  },
  methods: {
    handleCheckboxChange({ cell, rowIndex, key, value }) {
      this.setSingleValue(cell, rowIndex - 2, key, value);
      this.$emit("onChange");
    },

    setSingleValue(cell, rowIndex, key, value) {
      const actualValue = value ? "1" : "0";
      const exclusiveKeys = TableConfig.getExclusiveKeys();

      exclusiveKeys.forEach((exKey) => {
        this.$set(cell, exKey, "0");
        if (this.viewData[rowIndex]) {
          this.$set(this.viewData[rowIndex], exKey, "0");
        }
      });

      this.$set(cell, key, actualValue);
      if (this.viewData[rowIndex]) {
        this.$set(this.viewData[rowIndex], key, actualValue);
      }
    },
  },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/process/performanceManagement/components/PotentialRangeComponents/DynamicFixedTable.vue